import React from 'react';
import { maintainceDown } from '../../shared/assets/images';
import './mainta.scss';

const Maintaince = () => {
  return (
    <div className='Mainatince_container' >
      <center className='setting-img' style={{ padding: '60px 0px' }}>
        <img src={maintainceDown} />
      </center>
      <center>
        <div className='maint-text'>This Site is Under Maintenance</div>
        <div className='under-main'>
          The page you&apos;re looking for is currently under maintenance and will be back soon.
        </div>
        <div className='main-contact'>
          Contact us
        </div>
      </center>
    </div>
  );
};
export default Maintaince;